import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function FiscalPowerField() {
  const {formApi} = useVehicleFormContext();

  const handleFiscalPowerChange = () => {
    formApi.setValue('isFiscalPowerManualOverride', true, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <Field
      type="number"
      name="fiscalPower"
      decimalPlaces={0}
      label={i18n.t('entity.vehicle.labels.fiscalPower')}
      suffix={i18n.t('general.metric.pk')}
      onChange={handleFiscalPowerChange}
    />
  );
}
